angular.module('charts')
  .directive("dblProgressLineChart", function () {
      return {
          restrict: "E",
          scope: {
              graph: '=',
              historyData: '=',
              highThreshold: '@',
              lowThreshold: '@',
              startingProficiency: '=',
              noDataText: "@",
              yAxisLabel: '@'
          },
          templateUrl: '/resources/charts/directives/progress-line-chart/dbl-progress-line-chart.directive.html',
          controller: ['$scope', '$element', '$timeout', '$filter', 'moment', 'dblUserAgent', '$window', 'localeService', function ($scope, $element, $timeout, $filter, moment, dblUserAgent, $window, localeService) {

              var DAYS_IN_WEEK = 7;
              var formatterIndex = 0;
              var hasFutureWeekBeenSet = false;
              var today = moment.utc();
              var showArrow = true;
              var dataForTicks = [];
              var dataForTicksByTimestamp = {};
              var tickPositions = [];

              $scope.list = [];
              $scope.graphData = [];
              $scope.studentHistories = [];
              $scope.isIE = (dblUserAgent.getIEVersion() > 0);

              // Set default chart labels to use while loading
              $scope.chartConfig = {
                title: {
                  text: $filter('translate')('shared.labels.chartTitle')
                },
                lang: {
                  noData: $filter('translate')('shared.labels.noDataToDisplay')
                }
              };

              // Splice in student history data into graph data
              $scope.updateGraphData = function(graph) {
                  $scope.graphData = angular.copy(graph.proficiency_on_date_list);
                  $scope.studentHistories = angular.copy(graph.student_histories);

                  // Normalize timestamp
                  _.each($scope.studentHistories, function(item){
                      item.time_comp = moment(item.time_comp).format('YYYY-MM-DD');
                  });
              };

              var findItemByTodaysDate = function() {
                  var todaysItem =  _.find($scope.graphData, function(item) {
                      return item.date === moment().format('YYYY-MM-DD');
                  });
                  return todaysItem;
              };

              // Append Student History Data to Label List
              var appendHistoryData = function() {

                  // Remove paused lessons
                  var lessonsNotPaused = _.filter($scope.historyData, function(item){
                      return item.was_lesson_passed !== null;
                  });

                  // Group items by week labels
                  var group = _.groupBy(lessonsNotPaused, function(lesson){
                      return lesson.week;
                  });

                  // Append each group to a tick mark
                  _.each(dataForTicks, function(item, index) {
                      item.student_histories = group[index + 1];
                  });
              };

              var generateTicks = function () {
                  dataForTicks = [];
                  dataForTicksByTimestamp = {};
                  tickPositions = [];

                  var graphLength = $scope.graphData.length;

                  // Create labels for every week
                  for (var i = DAYS_IN_WEEK; i < graphLength; i += DAYS_IN_WEEK) {
                      var datum = $scope.graphData[i];

                      var item = {};
                      item.x = moment.utc(datum.date).valueOf();
                      // not rounded because we need precision to calculate growth later
                      item.y = datum.percent_complete;

                      dataForTicks.push(item);
                      dataForTicksByTimestamp[item.x] = item;
                      tickPositions.push(item.x);

                      // In case we have an non multiple of 7 number of praghData rows
                      if (i + DAYS_IN_WEEK >= graphLength && i + 1 < graphLength && datum.percent_complete < 100 && $scope.graphData[graphLength-1].percent_complete === 100) {
                        item = {};
                        item.previousWeekDate = moment.utc(datum.date).valueOf();
                        datum = $scope.graphData[graphLength-1];
                        item.x = moment.utc(datum.date).valueOf();
                        // not rounded because we need precision to calculate growth later
                        item.y = datum.percent_complete;

                        dataForTicks.push(item);
                        dataForTicksByTimestamp[item.x] = item;
                        tickPositions.push(item.x);
                      }
                    }
                // In case $scope.graphData has a length <= 7
                  if ( graphLength <= DAYS_IN_WEEK && $scope.graphData[graphLength -1] !== null) {
                    var newItem = {};
                    var newDatum = $scope.graphData[graphLength-1];
                    newItem.x = moment.utc(newDatum.date).valueOf();
                    // not rounded because we need precision to calculate growth later
                    newItem.y = newDatum.percent_complete;
                    dataForTicks.push(newItem);
                    dataForTicksByTimestamp[newItem.x] = newItem;
                    tickPositions.push(newItem.x);
                  }

                  appendHistoryData();
              };

              // Create a series of weekly proficiency in $scope.list from daily data
              var getProgressPercentages = function(oneDayPriorTimestamp) {
                  var today = findItemByTodaysDate();
                  var graphLength = $scope.graphData.length;

                  $scope.list = [];

                  // Plot the Starting Proficiency
                  $scope.list.push({
                    x: oneDayPriorTimestamp,
                    y: Math.round($scope.startingProficiency)
                  });

                  // Create data points for every week in the past
                  for (var i = DAYS_IN_WEEK; i < graphLength; i += DAYS_IN_WEEK) {
                      var datum = $scope.graphData[i];

                      if (datum.percent_complete === null) {
                          continue;
                      }

                      var item = {};
                      item.x = moment.utc(datum.date).valueOf();
                      item.y = Math.round(datum.percent_complete);

                      $scope.list.push(item);

                    // In case we have an non multiple of 7 number of graphData rows
                      if(i + DAYS_IN_WEEK >= graphLength && i + 1 < graphLength && datum.percent_complete < 100 && $scope.graphData[graphLength-1].percent_complete === 100){
                        datum = $scope.graphData[graphLength -1];

                        if (datum.percent_complete === null) {
                          continue;
                        }
                        item = {};
                        item.x = moment.utc(datum.date).valueOf();
                        item.y = Math.round(datum.percent_complete);

                        $scope.list.push(item);
                      }
                  }
                  // In case $scope.graphData has a length <= 7
                  if( graphLength <= DAYS_IN_WEEK && $scope.graphData[graphLength -1] !== null){
                    var newDatum = $scope.graphData[graphLength -1];
                    var newItem = {};
                    newItem.x = moment.utc(newDatum.date).valueOf();
                    newItem.y = Math.round(newDatum.percent_complete);
                    $scope.list.push(newItem);
                  }

                  var isFuture = moment.utc(oneDayPriorTimestamp) > moment.utc();
                  if (!isFuture) {
                      showArrow = true;
                  } else {
                      showArrow = false;
                  }

                  // Plot today
                  if(!_.isUndefined(today)) {
                      $scope.list.push({x: moment.utc(today.date).valueOf(), y: Math.round(today.percent_complete)});
                  }

                  // Make sure 'today' is inserted at the correct index
                  var sorted = _.sortBy($scope.list, function(point) {
                      return point.x;
                  });

                  return sorted;
              };

              var includeTotalTimeSpent = function (_labelData) {

                  var labelData = _labelData;

                  if(!_.isUndefined(labelData.student_histories)) {

                      var time_spent = _(labelData.student_histories).filter('time_spent_millis').pluck('time_spent_millis').value();

                      time_spent = _.sum(time_spent);
                      labelData.total_time = time_spent;
                  } else {
                      labelData.total_time = 0;
                  }

                  return labelData;
              };

              var includeHistoriesCount = function(_labelData) {

                  var labelData = _labelData;

                  if(!_.isUndefined(labelData.student_histories)) {
                      labelData.student_histories_count = labelData.student_histories.length;
                  } else {
                      labelData.student_histories_count = 0;
                  }

                  return labelData;
              };

              var formatXaxisLabels = function() {
                  var _label = this;

                  var curWeekClass, labelData;

                  // Initialize for each time labels are rendered (events aren't dependable)
                  if (_label.isFirst) {
                      formatterIndex = 0;
                      hasFutureWeekBeenSet = false;
                  }
                  formatterIndex ++;

                  // Set class for current week ending label
                  curWeekClass = '';
                  if(moment.utc(today.valueOf()).endOf('day') <= moment.utc(_label.value).endOf('day') && !hasFutureWeekBeenSet && showArrow) {
                      hasFutureWeekBeenSet = true;
                      curWeekClass = 'cur-week';
                  }

                  // Fetch point data that matches current label
                  var curVal = _label.value;
                  labelData = dataForTicksByTimestamp[curVal];

                  // Rules for labelData.total_time
                  labelData = includeTotalTimeSpent(labelData);

                  // Rules for labelData.student_histories_count
                  labelData = includeHistoriesCount(labelData);

                  // Calculate progress change for labels
                  var prevLabelData;
                  if (_label.isFirst) {
                      // There is no label at the assignment start so create a throwaway
                      // prevLabelData for calculating first week growth
                      prevLabelData = {
                          y: $scope.startingProficiency
                      };
                  } else {
                      var lastWeekTimestamp = moment.utc(curVal).subtract(DAYS_IN_WEEK,'d').valueOf();
                      prevLabelData = dataForTicksByTimestamp[lastWeekTimestamp];
                      if ( !prevLabelData && labelData.previousWeekDate ) {
                        prevLabelData = dataForTicksByTimestamp[labelData.previousWeekDate];
                      }
                  }

                  // Set classes for current week
                  var status = "no-change";
                  var absoluteDifference = 0;
                  var symbol = '';
                  if (!_.isUndefined(prevLabelData) && !_.isUndefined(labelData)) {
                      var difference = Math.round(labelData.y - prevLabelData.y);
                      absoluteDifference = Math.abs(difference);
                      var isGreater = difference > 0;
                      var isLess = difference < 0;

                      status = isGreater ? "greater" : isLess ? "less" : "no-change";
                      symbol = isGreater ? "+" : isLess ? "-" : "";
                  }

                  var html = '';
                  var weekLabel = $filter('translate')('assignments.weekX', { x: formatterIndex });

                  if(!_.isNull(labelData.y)) {
                      // Labels with percentage data
                      html = html + '<div class="hc-xlabel ' + status + " " + curWeekClass + '"><span class="hc-xlabel__percent">' + symbol + '' + absoluteDifference + '%</span><span class="hc-xlabel__date">' + weekLabel + '</span>';
                  } else {
                      // Labels without percentage data
                      html = html + '<div class="hc-xlabel ' + status + " " + curWeekClass + '"><span class="hc-xlabel__percent hc-xlabel__percent--empty"> -- </span><span class="hc-xlabel__date">' + weekLabel + '</span>';
                  }

                  // History data
                  var lessonTxt = $filter('translate')(
                    'assignments.lesson', { count: labelData.student_histories_count }
                  );
                  html = html + '<div class="hc-xlabel__history">' + $filter("minutes")(labelData.total_time) +  '</div> <div class="hc-xlabel__history">' + lessonTxt + '</div>';

                  return html + '</div>';
              };

              /* Watch for changes on scope object - since it is databound
               * it will react to any changes to the item.usageGraph object.
               * Note - make sure when you update the usageGraph object that
               * you use $scope.$apply() to update bindings. Or in this case
               * $timeout which clears the callstack and does a $scope.$apply();
               */
              $scope.$watchCollection('graph', function (graph) {
                  $timeout(function () {
                      if (graph) {
                          // Transform graph data
                          $scope.updateGraphData(graph);
                          $scope.drawGraph();
                      }
                  }, 0);

              });


              $scope.drawGraph = function () {

                  var first= _.first($scope.graphData);
                  var firstDay = first.date;
                  var lastDayDate = $scope.graphData[$scope.graphData.length - 1].date;
                  var lastDayTimestamp = moment.utc(lastDayDate).valueOf();
                  var oneDayPriorTimestamp = moment.utc(firstDay).subtract(1, 'days').valueOf();

                  var progressPercentages = getProgressPercentages(oneDayPriorTimestamp);
                  generateTicks();
                  $scope.chartConfig = {
                    chart: {
                      height: 420,
                      width: $('.line-chart-container').width(),
                      marginRight: 50,
                    },
                    xAxis: {
                      type: 'datetime',
                      endOnTick: true, // without this, highcharts tries to insert extra tick marks when only two are defined by us
                      tickPositions: tickPositions,
                      tickLength: 12,
                      tickWidth: 1.5,
                      lineColor: '#D8D8D8',
                      minPadding: 0,
                      labels: {
                        useHTML: true,
                        y: 16,
                        formatter: formatXaxisLabels
                      },
                    },
                    tooltip: {
                        formatter: function() {
                          var returnHtml = '';

                          var yValue = this.y;
                          if (this.series.tooltipOptions.valueSuffix) {
                            yValue = this.y + this.series.tooltipOptions.valueSuffix;
                          }
                          returnHtml += '<span style="color: ' + this.series.color + '">' + this.series.name +': <b>' + yValue + '</b></span>';

                          var xValue = this.x;
                          if (this.series.tooltipOptions.xDateFormatMoment) {
                            // Use moment.js to format the date according to locale
                            xValue = moment(xValue).locale(localeService.getLocale()).format(this.series.tooltipOptions.xDateFormatMoment);
                          }
                          returnHtml += '<br/><span>' + xValue + '</span>';

                          return returnHtml;
                        }
                    },
                    // Green   // Teal    // Teal
                    colors: ['#69BE28', '#0088B0', '#0088B0'],

                    title: {
                      text: ''
                    },

                    legend: {
                      enabled: false
                    },

                    credits: {
                      enabled: false
                    },

                    yAxis: [{
                      min: Number($scope.lowThreshold),
                      max: Number($scope.highThreshold),
                      floor: Number($scope.lowThreshold),
                      ceiling: Number($scope.highThreshold),
                      title: {
                        text: $scope.yAxisLabel,
                        enabled: true
                      },
                      gridLineColor: 'rgba(0, 0, 0, 0.07)'
                    }, {
                      min: Number($scope.lowThreshold),
                      max: Number($scope.highThreshold),
                      floor: Number($scope.lowThreshold),
                      ceiling: Number($scope.highThreshold),
                      allowDecimals: false,
                      title: {
                        text: 'Goal Range',
                        enabled: false
                      },
                      opposite: true,
                      gridLineWidth: 0,
                      labels: {
                        enabled: false
                      }
                    }, {
                      min: Number($scope.lowThreshold),
                      max: Number($scope.highThreshold),
                      floor: Number($scope.lowThreshold),
                      ceiling: Number($scope.highThreshold),
                      allowDecimals: false,
                      title: {
                        text: 'Baseline',
                        enabled: false
                      },
                      gridLineWidth: 0,
                      labels: {
                        enabled: false
                      }
                    }, {
                      min: Number($scope.lowThreshold),
                      max: Number($scope.highThreshold),
                      floor: Number($scope.lowThreshold),
                      ceiling: Number($scope.highThreshold),
                      allowDecimals: false,
                      title: {
                        text: 'Goal',
                        enabled: false
                      },
                      gridLineWidth: 0,
                      labels: {
                        enabled: false
                      }
                    }],

                    plotOptions: {
                      series: {
                        marker: {
                          enabled: true,
                          symbol: 'circle',
                          radius: 4
                        },
                        fillOpacity: 0.2
                      }
                    },

                    // Hack to fix chart gradient rendering and resizing when window size change
                    // per: https://github.com/pablojim/highcharts-ng/issues/300
                    func: function (chart) {
                      $scope.$evalAsync(function () {
                        chart.reflow();
                      });
                    },

                    series: [{
                      type: 'arearange',
                      name: 'Goal',
                      id: 'goal',
                      lineWidth: 0,
                      enableMouseTracking: false,
                      fillColor: {
                        linearGradient: {x1: 0, x2: 0, y1: 0, y2: 1},
                        stops: [
                          [0, 'rgba(105,190,140, .4)'],
                          [1, 'rgba(0,136,176, .2)']
                        ]
                      },
                      data: [
                        [oneDayPriorTimestamp, $scope.startingProficiency, $scope.startingProficiency],
                        [lastDayTimestamp, $scope.startingProficiency, 100]
                      ]

                    }, {
                      yAxis: 1,
                      type: 'line',
                      name: $filter('translate')('assignments.studentProgress'),
                      id: 'student-progress',
                      data: progressPercentages,
                      tooltip: {
                        xDateFormatMoment: 'LL',
                        valueSuffix: '%',
                      }
                    }, {
                      yAxis: 2,
                      type: 'line',
                      name: 'Student Base Line',
                      id: 'student-baseline',
                      dashStyle: 'dash',
                      marker: {
                        enabled: false
                      },
                      lineWidth: 1,
                      data: [{
                        x: oneDayPriorTimestamp,
                        y: $scope.startingProficiency,
                        label: 'Starting Goal'
                      }, {
                        x: lastDayTimestamp,
                        y: $scope.startingProficiency,
                        label: 'Ending Goal'
                      }],
                      enableMouseTracking: false
                    }, {
                      yAxis: 3,
                      type: 'line',
                      name: 'Student Goal',
                      id: 'student-goal',
                      dashStyle: 'dash',
                      marker: {
                        enabled: false
                      },
                      lineWidth: 1,
                      data: [{
                        x: oneDayPriorTimestamp,
                        y: $scope.startingProficiency,
                        label: 'Starting Goal'
                      }, {
                        x: lastDayTimestamp,
                        y: 100,
                        label: 'Ending Goal'
                      }],
                      enableMouseTracking: false
                    }]
                  };

                $scope.showGraph = true;
              };


            angular.element($window).bind('resize', function() {
              $scope.drawGraph();
            });

          }]
      };
  });
